module.exports = __webpack_public_path__ + "static/media/tiro-training-ltd.e9f9b035.jpg";